// extracted by mini-css-extract-plugin
export default {"customScrollbar":"Styles_customScrollbar__Cp3Gs"};